import React from 'react';
import ReactDOM from 'react-dom';

import FormActions from '../../../../shared/actions/form';

import ElementConstants from '../../../../shared/constants/elements';

import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';

import TableMatrix from '../../../../shared/components/widgets/table-matrix';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';
import DraggableItems from "../../../constants/dnd";
import { DragSource, DropTarget } from '../../../../../../../common/react-dnd-2.6.0/dist/ReactDnD.min';

const inputSource = {
	// React-DnD method returns dragged item props upon initiating drag operation
	beginDrag(props) {
		return props;
	}
}

const dropTarget = {

	/**
	 * React-DnD @method drop
	 * dispatches input move event when user drops an input in an input group target.
	 * The order is determined by the position of the dragged element relative to
	 * the existing elements.
	 * @params are all from React-DnD
	 */
	drop(props, monitor, component) {
		const draggedItem = monitor.getItem();
		const targetItem = props;

		// Determine rectangle on screen
		const targetBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();
		// Get vertical middle of target
		const targetMiddleY = ( targetBoundingRect.bottom - targetBoundingRect.top ) / 2;
		// Determine mouse position
		const clientOffset = monitor.getClientOffset();
		// Get number of pixels to the top of target
		const targetClientY = clientOffset.y - targetBoundingRect.top;

		if (
			!(( draggedItem.row && targetItem.row ) || ( draggedItem.column && targetItem.column ))
		) {
			return;
		}

		if ( monitor.canDrop() ) {
			FormActions.moveInputFromGroup(draggedItem.fieldsetIndex, draggedItem.rowIndex, draggedItem.index, draggedItem.choiceNumber, targetItem.choiceNumber, draggedItem.row ? 'rows' : 'columns');
			// Reset drop-zone state after drop operation
			component.setState({
				sameSection: (( draggedItem.row && targetItem.row ) || ( draggedItem.column && targetItem.column )),
				topQuadrantHovered: false,
				bottomQuadrantHovered: false
			});
			return;
		}
	},

	/**
	 * React-DnD @method hover
	 * display an active drop-zone upon hovering an input in a group.
	 * The order is determined by the position of the dragged element relative to
	 * the existing elements.
	 * @params are all from React-DnD
	 */
	hover(props, monitor, component) {
		const draggedItem = monitor.getItem();
		const targetItem = props;

		// Determine rectangle on screen
		const targetBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();
		// Get vertical middle of target
		const targetMiddleY = ( targetBoundingRect.bottom - targetBoundingRect.top ) / 2;
		// Determine mouse position
		const clientOffset = monitor.getClientOffset();
		// Get number of pixels to the top of target
		const targetClientY = clientOffset.y - targetBoundingRect.top;

		// Mouse is positioned in top quadrant of drop target moving down
		if ( targetClientY < targetMiddleY ) {
			component.setState({
				sameSection: (( draggedItem.row && targetItem.row ) || ( draggedItem.column && targetItem.column )),
				topQuadrantHovered: true,
				bottomQuadrantHovered: false
			});
		}

		// Mouse is positioned in bottom quadrant of drop target moving up
		if ( targetClientY > targetMiddleY ) {
			component.setState({
				sameSection: (( draggedItem.row && targetItem.row ) || ( draggedItem.column && targetItem.column )),
				topQuadrantHovered: false,
				bottomQuadrantHovered: true
			});
		}
	}

}

@DragSource(DraggableItems.INPUT_FROM_GROUP, inputSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	connectDragPreview: connect.dragPreview(),
	isDragging: monitor.isDragging()
}))
@DropTarget([DraggableItems.INPUT_FROM_GROUP, DraggableItems.INPUT_FROM_GROUP], dropTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop()
}))
class TableQuestion extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			row,
			onBlur,
			onClick,
			isOver,
			connectDropTarget,
			connectDragSource,
			connectDragPreview,
			isDragging,
			setRef
		} = this.props;

		const rowClasses = ( isDragging ) ? 'dragging row' : 'row';
		const topDropZoneClasses = ( isOver && this.state.sameSection && this.state.topQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';
		const bottomDropZoneClasses = ( isOver && this.state.sameSection && this.state.bottomQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';


		return connectDropTarget(
				connectDragPreview(
					<div>
						<div className={topDropZoneClasses}></div>
						<div className={rowClasses} onBlur={onBlur}>
							<div style={{ padding: 0, margin: '0 5px 2px 0' }} className='left tools'>
								{connectDragSource(
									<a className='move' href='javascript:;'>
										<SVGIcon name='drag-handle' />
									</a>
								)}
							</div>
							<InputLabel ref={refElem => setRef(`${row.uniqueId}_label`, refElem)} label={row.label} />
							<div className='tools'>
								<a className='delete' href='javascript:;' onClick={onClick}>
									<SVGIcon name='trash-o' />
								</a>
							</div>
						</div>
						<div className={bottomDropZoneClasses}></div>
					</div>
				))
	}
}

@DragSource(DraggableItems.INPUT_FROM_GROUP, inputSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	connectDragPreview: connect.dragPreview(),
	isDragging: monitor.isDragging()
}))
@DropTarget([DraggableItems.INPUT_FROM_GROUP, DraggableItems.INPUT_FROM_GROUP], dropTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop()
}))
class TableAnswer extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			column,
			onBlur,
			onClick,
			isOver,
			connectDropTarget,
			connectDragSource,
			connectDragPreview,
			isDragging,
			setRef
		} = this.props;

		const columnClasses = ( isDragging ) ? 'dragging column' : 'column';
		const topDropZoneClasses = ( isOver && this.state.sameSection && this.state.topQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';
		const bottomDropZoneClasses = ( isOver && this.state.sameSection && this.state.bottomQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';


		return connectDropTarget(
				connectDragPreview(
					<div>
						<div className={topDropZoneClasses}></div>
						<div className={columnClasses} onBlur={onBlur}>
							<div style={{ padding: 0, margin: '0 5px 2px 0' }} className='left tools'>
								{connectDragSource(
									<a className='move' href='javascript:;'>
										<SVGIcon name='drag-handle' />
									</a>
								)}
							</div>
							<InputLabel ref={refElem => setRef(`${column.uniqueId}_label`, refElem)} label={column.label} placeholder='Answer' />
							<div className='tools'>
								<a className='delete' href='javascript:;' onClick={onClick}>
									<SVGIcon name='trash-o' />
								</a>
							</div>
						</div>
						<div className={bottomDropZoneClasses}></div>
					</div>
				))
	}
}

export default class TableElement extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			addedColumn: false,
			addedRow: false,
		};

		this.addColumn = this.addColumn.bind(this);
		this.addRow = this.addRow.bind(this);
		this.changeAnswerStyle = this.changeAnswerStyle.bind(this);
	}

	componentDidUpdate() {
		// Add rows and columns to new table
		if (!this.props.data.initialized) {
			const {
				fieldsetIndex,
				rowIndex,
				index
			} = this.props;

			FormActions.initializeTable(fieldsetIndex, rowIndex, index);
		}

		if (this.state.addedColumn) {
			let { columns } = this.props.data;
			let newInput = ReactDOM.findDOMNode(this.refs[`${columns[columns.length - 1].uniqueId}_label`].refs.input);

			// Set timeout ensures the input will be focused after blur completes fully
			setTimeout(() => {
				newInput.focus();
			}, 20)

			this.setState({
				addedColumn: false
			});
		}

		if ( this.state.addedRow ) {
			let { rows } = this.props.data;
			let newInput = ReactDOM.findDOMNode(this.refs[`${rows[rows.length - 1].uniqueId}_label`].refs.input);

			// Set timeout ensures the input will be focused after blur completes fully
			setTimeout(() => {
				newInput.focus();
			}, 20)

			this.setState({
				addedRow: false
			});
		}
	}

	addColumn() {
		let {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		this.setState({
			addedColumn: true
		});

		FormActions.addColumnToTable(fieldsetIndex, rowIndex, index);
	}

	addRow() {
		let {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		this.setState({
			addedRow: true
		});

		FormActions.addRowToTable(fieldsetIndex, rowIndex, index);
	}

	changeAnswerStyle() {
		let {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		let {
			radioStyle,
			checkboxStyle
		} = this.refs;

		if ( ReactDOM.findDOMNode(radioStyle).checked ) {
			FormActions.setTableAnswerStyle(fieldsetIndex, rowIndex, index, 'radio');
		} else if ( ReactDOM.findDOMNode(checkboxStyle).checked ) {
			FormActions.setTableAnswerStyle(fieldsetIndex, rowIndex, index, 'checkbox');
		}
	}

	handleBlur(element, type, subElementIndex, event) {
		let {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		let oldLabel = element.label;
		let newLabel = this.refs[`${element.uniqueId}_label`].refs.input.value;

		if ( newLabel !== '' && newLabel !== oldLabel ) {
			if ( type === 'column' ) {
				FormActions.updateTableColumnLabel(fieldsetIndex, rowIndex, index, subElementIndex, newLabel);
			} else if ( type === 'row' ) {
				FormActions.updateTableRowLabel(fieldsetIndex, rowIndex, index, subElementIndex, newLabel);
			}
		}
	}

	remove(element, type, subElementIndex, event) {
		let {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		setTimeout(() => {
			if ( type === 'column' ) {
				FormActions.removeTableColumn(fieldsetIndex, rowIndex, index, subElementIndex);
			} else if ( type === 'row' ) {
				FormActions.removeTableRow(fieldsetIndex, rowIndex, index, subElementIndex);
			}
		}, 0);
	}

	setRef(key, ref) {
		this.refs[key] = ref;
	};

	render() {
		let {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel,
			editModeEnabled
		} = this.props;

		let {
			initialized,
			label,
			hint,
			rows,
			columns,
			required,
			style
		} = this.props.data;

		let localization = new Localization(window.edlio.localizations);

		// These are used to prevent screen jumping when adding new rows or columns
		let columnsSectionId = `${fieldsetIndex}_${rowIndex}_${index}_columns`;
		let rowsSectionId = `${fieldsetIndex}_${rowIndex}_${index}_rows`;

		return (
			<div className='table input-group'>
				<header>
					<InputLabel ref='label' label={label} required={required} usePlaceholderLabel={usePlaceholderLabel} />
					<InputHint ref='hint' hint={hint} />
				</header>
				<div className='form'>
					<section className='rows' id={rowsSectionId}>
						<h2>{localization.localize("Questions (Rows)")}</h2>
						{
							rows.map((row, i) => {
								return (
									<TableQuestion
										row={row}
										key={row.uniqueId}
										choiceNumber={i}
										fieldsetIndex={fieldsetIndex}
										rowIndex={rowIndex}
										index={index}
										onBlur={this.handleBlur.bind(this, row, 'row', i)}
										onClick={this.remove.bind(this, row, 'row', i)}
										setRef={this.setRef.bind(this)}
									/>
								);
							})
						}
						<a href={`#${rowsSectionId}`} onClick={this.addRow}>{localization.localize("Add row")}</a>
					</section>
					<section ref='columns' className='columns' id={columnsSectionId}>
						<h2>{localization.localize("Answers (Columns)")}</h2>
							{
								columns.map((column, i) => {
									return (
										<TableAnswer
											column={column}
											key={column.uniqueId}
											choiceNumber={i}
											fieldsetIndex={fieldsetIndex}
											rowIndex={rowIndex}
											index={index}
											onBlur={this.handleBlur.bind(this, column, 'column', i)}
											onClick={this.remove.bind(this, column, 'column', i)}
											setRef={this.setRef.bind(this)}
										/>
									);
								})
							}
							<a href={`#${columnsSectionId}`} onClick={this.addColumn}>{localization.localize("Add column")}</a>
					</section>
					<section className='type-selection'>
						<h2>{localization.localize("Answer Style")}</h2>
						<div className='input'>
							<input
								ref='radioStyle'
								id={`${fieldsetIndex}_${rowIndex}_${index}_radio_answer_style_radio`}
								type='radio'
								name={`${fieldsetIndex}_${rowIndex}_${index}_answer-style`}
								onChange={this.changeAnswerStyle}
								defaultChecked={style === 'radio'}
							></input>
						<label htmlFor={`${fieldsetIndex}_${rowIndex}_${index}_radio_answer_style_radio`}>{localization.localize("multiple choice (allow only one answer per row)")}</label>
						</div>
						<div className='input'>
							<input
								ref='checkboxStyle'
								id={`${fieldsetIndex}_${rowIndex}_${index}_checkbox_answer_style_radio`}
								type='radio'
								name={`${fieldsetIndex}_${rowIndex}_${index}_answer-style`}
								onChange={this.changeAnswerStyle}
								defaultChecked={style === 'checkbox'}
							></input>
						<label htmlFor={`${fieldsetIndex}_${rowIndex}_${index}_checkbox_answer_style_radio`}>{localization.localize("checkboxes (allow multiple answers per row)")}</label>
						</div>
					</section>
				</div>
				<TableMatrix
					columns={columns}
					rows={rows}
					style={style}
					activeInputs={false}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/input-groups/table.js